module.exports = __webpack_public_path__ + "static/favicon-c9e3d96d4736da7e51468849f8473433.ico";